/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

export const SHOWDOWN_MARKDOWN_OPTIONS = {
  underline: true,
  emoji: true
};

export const TURNDOWN_MARKDOWN_OPTIONS = {
  emDelimiter: '*',
  strongDelimiter: '**',
  blankReplacement: function (_content, node) {
    return node.isBlock ? '\n\n\u200B\n\n' : '';
  },
  keepReplacement: function (_content, node) {
    return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
  },
  defaultReplacement: function (content, node) {
    return node.isBlock ? '\n\n' + content + '\n\n' : content;
  }
};

// List of toolbar actions for rich-text editor
export const RICH_TEXT_TOOLBAR_ACTIONS = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  EMOJI: 'EMOJI',
  BULLET_LIST: 'BULLET_LIST',
  ORDERED_LIST: 'ORDERED_LIST',
  LINK: 'LINK',
  CUSTOM_IMAGE: 'CUSTOM_IMAGE',
  CUSTOM_TOOLTIP: 'CUSTOM_TOOLTIP',
  CUSTOM_VARIABLE: 'CUSTOM_VARIABLE',
  HEADING: 'HEADING'
};
// List of toolbar actions for rich-text editor
export const RICH_TEXT_INLINE_ACTIONS = {
  EXPRESSIONS: {
    key: 'expressions',
    tooltip: `When enabled, the value will be evaluated as an expression.
      If not enabled, the value will be treated as a literal string.
      Use expressions for dynamic calculations or variables, and literals for static content.
      Examples:
      - Plain variable value: 5
      - Expression: 5 + {{var1}} - {{var2}}`,
    displayText: '/'
  }
};

// Default toolbar action for rich text editor
export const RICH_TEXT_DEFAULT_TOOLBAR_ACTIONS ={
  ...Object.fromEntries(
    Object.entries(RICH_TEXT_TOOLBAR_ACTIONS).filter(
      ([key]) => key !== RICH_TEXT_TOOLBAR_ACTIONS.HEADING
    )
  )
};
